import {getSystemCountry} from './locale';

export interface IdentityInterface {
    isNumberComplete(identity: string): boolean;
    maxLength(): number;
}

interface IdentityImplementationMap extends Partial<Record<ReturnType<typeof getSystemCountry>, IdentityInterface>> {}

const sweIdendity: IdentityInterface = {
    isNumberComplete: (identity: string) => {
        return identity.length === 12;
    },
    maxLength: () => 12
};

const finIdentity: IdentityInterface = {
    isNumberComplete: (identity: string) => {
        return identity.match(/^[0-9]{6}[+\-YXWVUABCDEF][0-9]{3}[0-9A-Z]$/i) !== null;
    },
    maxLength: () => 11
};

const identityImpl: IdentityImplementationMap = {
    fi: finIdentity,
    sv: sweIdendity
};

export const getIdentityImpl = (): IdentityInterface => {
    const country = getSystemCountry();
    return identityImpl[country] ?? sweIdendity;
};
